var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { useSyncExternalStore } from "react";
class WarehousePinSelectionStore {
  constructor() {
    __publicField(this, "selectedWarehouseId", null);
    __publicField(this, "listeners", /* @__PURE__ */ new Set());
    __publicField(this, "subscribe", (listener) => {
      this.listeners.add(listener);
      return () => {
        this.listeners.delete(listener);
      };
    });
    __publicField(this, "getSnapshot", () => {
      return this.selectedWarehouseId;
    });
    __publicField(this, "getServerSnapshot", () => {
      return null;
    });
    __publicField(this, "selectWarehouse", (warehouseId) => {
      this.selectedWarehouseId = warehouseId;
      this.listeners.forEach((listener) => listener());
    });
    __publicField(this, "clearSelection", () => {
      this.selectedWarehouseId = null;
      this.listeners.forEach((listener) => listener());
    });
  }
}
const warehousePinSelectionStore = new WarehousePinSelectionStore();
const useWarehousePinSelection = () => {
  const selectedWarehouseId = useSyncExternalStore(
    warehousePinSelectionStore.subscribe,
    warehousePinSelectionStore.getSnapshot,
    warehousePinSelectionStore.getServerSnapshot
  );
  return {
    selectedWarehouseId,
    selectWarehouse: warehousePinSelectionStore.selectWarehouse,
    clearSelection: warehousePinSelectionStore.clearSelection
  };
};
export {
  useWarehousePinSelection
};
